// extracted by mini-css-extract-plugin
export default {"General":"General_General__q2Jlx"};